<vl-modal :id="modalId" :closable="true" mod-medium>
    <form class="vl-form" @submit="onSubmit">
        <vl-title tag-name="h3">{{ title }}</vl-title>
        <vl-u-spacer mod-small/>
        <vl-form-grid mod-stacked>
            <vl-column width="12">
                <aeg-field-validation-wrapper :error-message="errors.email" name="E-mail" mod-required
                                              #default="{hasErrors}">
                    <vl-input-field name="email" v-model="email" v-bind="emailProps" :mod-error="hasErrors" mod-block/>
                </aeg-field-validation-wrapper>
            </vl-column>
            <vl-column width="12" v-if="actor.emails.length > 1">
                <aeg-field-validation-wrapper :error-message="errors.email" name="E-mail CC" mod-required
                                              #default="{hasErrors}">
                    <vl-input-field name="emailCc" v-model="emailCc" v-bind="emailCcProps" :mod-error="hasErrors"
                                    mod-block/>
                </aeg-field-validation-wrapper>
            </vl-column>
            <vl-column>
            </vl-column>
            <vl-action-group>
                <vl-button type="submit" mod-large :mod-disabled="disableSubmit || savingEmails">Wijzigingen opslaan
                </vl-button>
                <vl-link @click.prevent="onCloseModal" icon="cross" mod-icon-before>
                    Annuleer
                </vl-link>
            </vl-action-group>
        </vl-form-grid>
    </form>
</vl-modal>